var shareUrlFacebook = 'https://www.facebook.com/sharer/sharer.php?u=';
var shareUrlMessenger = 'http://www.facebook.com/dialog/send?link=';
if (typeof auth_facebook_id !== 'undefined') {
    shareUrlMessenger = 'http://www.facebook.com/dialog/send?app_id=' + auth_facebook_id + '&link=';
}
var shareUrlTwitter = 'https://twitter.com/intent/tweet?';
var shareUrlLinkedin = 'https://www.linkedin.com/shareArticle?mini=true&';
var shareUrlBluesky = 'https://bsky.app/intent/post?text=';
var shareUrlMastodon = 'https://mastodon.social/share?text=';
var shareUrlReddit = 'https://www.reddit.com/submit?url=';
var shareUrlWhatsApp = 'https://api.whatsapp.com/send?text=';

// Fonction de partage générique
function openShareWindow(url) {
    let winWidth = 630;
    let winHeight = 650;
    let winTop = (screen.height / 2) - (winHeight / 2);
    let winLeft = (screen.width / 2) - (winWidth / 2);
    window.open(url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}

// Fonctions de partage
global.fbShare = function(url) { openShareWindow(shareUrlFacebook + url); }
global.messengerShare = function(url) { openShareWindow(shareUrlMessenger + url + '&redirect_uri=' + url); }
global.twitterShare = function(url, question) { openShareWindow(shareUrlTwitter + 'text=' + question + '&url=' + url); }
global.linkedinShare = function(url, question) { openShareWindow(shareUrlLinkedin + 'summary=' + question + '&url=' + url); }
global.blueskyShare = function(url, question) { openShareWindow(shareUrlBluesky + encodeURIComponent(question + ' ' + url)); }
global.mastodonShare = function(url, question) { openShareWindow(shareUrlMastodon + encodeURIComponent(question + ' ' + url)); }
global.redditShare = function(url, question) { openShareWindow(shareUrlReddit + url + '&title=' + encodeURIComponent(question)); }
global.whatsappShare = function(url, question) { openShareWindow(shareUrlWhatsApp + encodeURIComponent(question + ' ' + url)); }

global.getShareUrl = function(socials) {
    let url = socials.data('url');
    if (!url.includes(':')) url = $('base').attr('href') + url;
    return url;
}

global.initSocialShares = function(target) {
    if (target) target = $(target).find('.socials');
    else target = $('.socials');

    target.find('.icon-fb').click(function (event) { event.preventDefault(); fbShare(getShareUrl($(this).parents('.socials'))); });
    target.find('.icon-messenger').click(function (event) { event.preventDefault(); messengerShare(getShareUrl($(this).parents('.socials'))); });
    target.find('.icon-twitter').click(function (event) { event.preventDefault(); let socials = $(this).parents('.socials'); twitterShare(getShareUrl(socials), socials.data('name')); });
    target.find('.icon-linkedin').click(function (event) { event.preventDefault(); let socials = $(this).parents('.socials'); linkedinShare(getShareUrl(socials), socials.data('name')); });
    target.find('.icon-bluesky').click(function (event) { event.preventDefault(); let socials = $(this).parents('.socials'); blueskyShare(getShareUrl(socials), socials.data('name')); });
    target.find('.icon-mastodon').click(function (event) { event.preventDefault(); let socials = $(this).parents('.socials'); mastodonShare(getShareUrl(socials), socials.data('name')); });
    target.find('.icon-reddit').click(function (event) { event.preventDefault(); let socials = $(this).parents('.socials'); redditShare(getShareUrl(socials), socials.data('name')); });
    target.find('.icon-whatsapp').click(function (event) { event.preventDefault(); let socials = $(this).parents('.socials'); whatsappShare(getShareUrl(socials), socials.data('name')); });
    target.find('.icon-copy').click(function (event) { event.preventDefault(); clipboardCopy(getShareUrl($(this).parents('.socials'))); });

    // Partage natif du navigateur
    let shareIcon = target.find('.icon-share');
    if (navigator.share) {
        shareIcon.click(function (event) {
            event.preventDefault();
            let socials = $(this).parents('.socials');
            navigator.share({
                title: socials.data('name'),
                url: getShareUrl(socials)
            }).catch((err) => console.error("Erreur de partage", err));
        });
    } else {
        shareIcon.hide();
    }
}
